module.exports = __webpack_public_path__ + "static/img/ej.721bf29d.png";